import { render, staticRenderFns } from "./DesignWorkDetails.vue?vue&type=template&id=91404f76&scoped=true&"
import script from "./DesignWorkDetails.vue?vue&type=script&lang=js&"
export * from "./DesignWorkDetails.vue?vue&type=script&lang=js&"
import style0 from "./DesignWorkDetails.vue?vue&type=style&index=0&id=91404f76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91404f76",
  null
  
)

export default component.exports